import { render, staticRenderFns } from "./safe-statistics.vue?vue&type=template&id=911a5cac&scoped=true&"
import script from "./safe-statistics.vue?vue&type=script&lang=js&"
export * from "./safe-statistics.vue?vue&type=script&lang=js&"
import style0 from "./safe-statistics.vue?vue&type=style&index=0&id=911a5cac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "911a5cac",
  null
  
)

export default component.exports